import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import rule1 from '../../assets/images/activity/rule1@2x.png';
import rule2 from '../../assets/images/activity/rule2@2x.png';
import {Toast} from "antd-mobile";

class Award extends Component {
  render () {
    return (
      <div className='award-detail'>
        <Link to='/spreadAssist/step'>
          <img src={rule1} alt=''></img>
        </Link>
        <Link to='' onClick={() => Toast.info('规则完善中，敬请期待！', 2) }>
          <img src={rule2} alt=''></img>
        </Link>
      </div>
    )
  }
}

export default Award;